import type { Middleware } from 'redux';

const dependencyInjector = (deps: any) => {
  const middleware: Middleware = (store) => (next) => (action: any) =>
    /* istanbul ignore next */
    typeof action === 'function' ? action({ ...deps, ...store }) : next(action);
  return middleware;
};

export default dependencyInjector;
